// extracted by mini-css-extract-plugin
module.exports = {"title":"ForgotPasswordForm_title__1u86W","submit":"ForgotPasswordForm_submit__1h2V_","backToLogin":"ForgotPasswordForm_back-to-login__3cAr7"};